import { TranslationContentType } from "../shared/contentTypes";

export interface ICoreLanguageManagerService {
  readonly language_code: string,
  translate(contentType: TranslationContentType, contentID: number, de_defaultValue: string): string
}

declare var ya_CoreLanguageManagerService: ICoreLanguageManagerService;

/** Sprachen Manager der es ermöglich die unterschiedlichen Übersetzungen bereitzustellen.
 * Es muss beim sprachwechsel, die benötigte sprache laden und erst danach wird die Sprache abgerufen, dafür ist der abruf danach synchron.
 */
export class CoreLanguageManager {

  // ! Achtung, das ist momentan nur eine Quick and dirty Lösung, um mehrere Sprachen zu nutzen. Es muss eine richtige lösung gefunden werden.
  public static translate(contentType: TranslationContentType, contentID: number, de_defaultValue: string): string {
    if (ya_CoreLanguageManagerService) {
      if (ya_CoreLanguageManagerService.language_code === "de") {
        return de_defaultValue; // keine übersetzung für "de" notwendig
      } else {
        // todo central kann eigentlich aus dem contenttype ermittelt werden
        return ya_CoreLanguageManagerService.translate(contentType, contentID, de_defaultValue);
      }
    } else {
      console.error("CoreLanguageManagerService.translate", "global service not created yet");
      return de_defaultValue;
    }
  }
}
